import React, { useState } from 'react';
import { Chip } from 'primereact/chip';
import { observer } from 'mobx-react-lite';
import { PaymentServiceWithVersionsResponseType } from '../../../../../api/types/payments/payment-template';
import CancelButton from '../../../../../component/ui/buttons/cancel-button/cancel-button';
import ApproveButtons from '../../../../../component/ui/buttons/approve-button/approve-buttons';
import { createNewServiceOperation } from '../operations/create-new-service-operation';
import globalProgramStore from '../../../../../stores/program-store';
import globalConfigStore from '../../../../../stores/global-config-store';
import { PaymentServicesTable } from '../../../../payments/tabs/componenets/payment-services-table';

interface AddNewServiceToProgramModel {
  closeDialog: () => void;
  selectedYear: number;
}

export const DialogAddNewServiceToProgram: React.FC<AddNewServiceToProgramModel> =
  observer(({ selectedYear, closeDialog }) => {
    const [selectedService, setSelectedService] = useState<
      PaymentServiceWithVersionsResponseType[]
    >([]);

    const [loading, setLoading] = useState(false);

    const handleApprove = async () => {
      const branchId = globalConfigStore.rootFilter.currentBranches?.id;
      const selectedServicesIds = selectedService.map((item) => item.id);
      await createNewServiceOperation(
        branchId,
        globalProgramStore.getCurrentId(),
        selectedYear,
        selectedServicesIds,
        setLoading,
        closeDialog,
      );
    };

    return (
      <div>
        <PaymentServicesTable
          selectionMode="multiple"
          selectedServices={selectedService}
          onSelectionChange={setSelectedService}
        />

        {selectedService.map((serviceItem, index) => (
          <Chip
            key={serviceItem.id}
            label={`${serviceItem.paymentServiceName}`}
            removable={true}
            onRemove={() => {
              setSelectedService(
                selectedService.filter(
                  (_, serviceItemIndex) => serviceItemIndex !== index,
                ),
              );
            }}
            style={{ marginLeft: '8px', marginTop: '8px' }}
          />
        ))}

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left',
            marginTop: '20px',
            paddingBottom: '10px',
          }}
        >
          <CancelButton
            onClick={() => {
              closeDialog();
            }}
          />

          <div style={{ width: '10px' }} />
          <ApproveButtons isLoading={loading} onClick={handleApprove} />
        </div>
      </div>
    );
  });
